import "./Pitch.scss";

import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import { getRichPitchName } from "../../lib/audioTools";

class Pitch extends PureComponent {
	static propTypes = {
		name: PropTypes.string
	};

	render() {
		let { name } = this.props;
		let n = getRichPitchName(name);
		let [ letter, symbol ] = Array.from(n);

		return (
			<span>
				{ letter }
				{ symbol && (
					<span className="pitch-symbol">
						{ symbol }
					</span>
				) }
			</span>
		);
	}
}

export default Pitch;
